import React, { useEffect, useState } from "react";
import { useGetTarifByCabinetQuery } from "../../../utils/api/tarif/tarif.api";
import { formatCurrency, showModal, useUser } from "../../../utils/Utils";
import { AlertInfo } from "../../common/Alert";
import BootstrapTable from "react-bootstrap-table-next";
import { BsTrash } from "react-icons/bs";
import { CustomPagination } from "../../common/CustomPagination";
import TableSkeleton from "../../common/TableSkeleton";
import { MdOutlineModeEdit } from "react-icons/md";
import { Tarif } from "../../../utils/api/tarif/tarif.type";
import AddOrEditTArifModal from "./modal/AddOrEditTArifModal";
import { UseDeleteTarif } from "./form/AddOrEditTarifForm";

const BtnDelete = ({ slug }: { slug: string }) => {
  const onDelete = UseDeleteTarif(slug);

  return (
    <button
      className="btn with-tooltip btn-action-icon-delete"
      data-tooltip-content={"Supprimer"}
      style={{ color: "#E53E3E" }}
      onClick={onDelete}
    >
      <BsTrash />
    </button>
  );
};
function TarificationTable() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const user = useUser();
  const { data = { results: [], count: 0 }, isLoading,refetch } =
    useGetTarifByCabinetQuery({
      page,
      limit,
      slug: user?.slug,
    });

    useEffect(() => {
      if (!isLoading) refetch();
    }, []);

  const actionFormatter = (cell: string, row: Tarif) => {
    return (
      <>
        <div className="d-flex justify-content-center gap-3">
          <div className="container-btn-action-icon-modal">
            <button
              className="btn btn-action-icon-edit with-tooltip"
              data-tooltip-content="Modifier"
              onClick={() => showModal(`editTarifModal${cell}`)}
            >
              <MdOutlineModeEdit />
            </button>
          </div>

          <div className="container-btn-action-icon-modal">
            <BtnDelete slug={cell} />
          </div>
        </div>
        <AddOrEditTArifModal modalId={`editTarifModal${cell}`} item={row} />
      </>
    );
  };

  const columns = [
    {
      dataField: "denomination",
      text: `Dénomination`,
    },
    {
      dataField: "montant",
      text: "Montant",
      formatter: (cell) => formatCurrency(cell),
    },
    {
      dataField: "slug",
      text: "Action",
      formatter: actionFormatter,
    },
  ];

  return (
    <>
      {isLoading && <TableSkeleton headers={columns} />}
      {!isLoading && (
        <>
          <BootstrapTable
            keyField="id"
            data={data?.results}
            columns={columns}
            rowClasses="custom-table-row-class"
            condensed
            hover
            wrapperClasses="table-responsive admin-table"
            noDataIndication={() => (
              <AlertInfo message="Aucune donnée trouvée" />
            )}
          />
          <div className="custom-pagination-container">
            <CustomPagination
              nbPages={data?.count}
              page={page}
              onChange={(page, perPage) => {
                setLimit(perPage);
                setPage(page);
              }}
              perPage={limit}
            />
          </div>
        </>
      )}
    </>
  );
}

export default TarificationTable;
